export const version = "1.7.19";
export const channel = "release";
export const gitcommit = "unknown";
